var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"bandEdit":_vm.bandEdit},on:{"click":_vm.editT}},[_c('i',{staticClass:"far fa-pencil-alt"})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ml-5"},[_c('i',{staticClass:"far fa-trash-alt"})])
}]

export { render, staticRenderFns }